<template>
  <div class="project-detail">
    <a-row type="flex" justify="space-between">
      <a-col :span="14">
        <!-- 播放器 -->
        <div class="scratch-player">
          <iframe
            :src="
              workInfo.workFile_url
                ? '/scratch3/player.html?projectURL=' + workInfo.workFile_url
                : 'about:blank'
            "
            id="player"
            frameborder="0"
            width="100%"
            height="100%"
            scrolling="no"
          ></iframe>
        </div>
        <!-- 作品信息 -->
        <div class="project-info">
          <a-row>
            <a-col :span="8">
              <div class="project-meta">
                <h2 class="title">{{ workInfo.workName }}</h2>
                <p class="time">{{ workInfo.createTime }}</p>
                <div class="work-tag-wrapper" v-if="workInfo.workTag">
                  <a-tag
                    class="work-tag"
                    v-for="(tag, index) in workInfo.workTag.split(',')"
                    :key="index"
                    color="blue"
                    >{{ tag }}</a-tag
                  >
                </div>
              </div>
            </a-col>
            <a-col :span="16">
              <div class="project-op">
                <a-row>
                  <a-col :span="6">
                    <div class="project-star">
                      <vue-clap-button
                        class="clap"
                        @cancel="starWork"
                        @clap="starWork"
                        icon="good"
                        :initClicked="isStar"
                      />
                      <div>
                        <p style="margin-bottom:20px">点赞</p>
                        <p>{{ workInfo.starNum }}</p>
                      </div>
                    </div>
                  </a-col>
                  <a-col :span="6">
                    <div class="project-collect">
                      <vueClapButton
                        class="clap"
                        @cancel="collectWork"
                        @clap="collectWork"
                        icon="love"
                        :initClicked="isCollect"
                      />
                      <div>
                        <p style="margin-bottom:20px">收藏</p>
                        <p>{{ workInfo.collectNum }}</p>
                      </div>
                    </div>
                  </a-col>
                  <a-col :span="8">
                    <div class="project-rate">
                      <a-tooltip :title="rateDesc[hoverWorkScore]">
                        <a-rate
                          v-model="workScore"
                          @change="scoreWork"
                          @hoverChange="onHoverWorkScore"
                          style="font-size: 20px"
                        />
                      </a-tooltip>
                      <span class="ant-rate-text"
                        >{{ workInfo.scoreNum || 0 }}个评分,平均{{
                          (workInfo.average || 0).toFixed(1)
                        }}</span
                      >
                    </div>
                  </a-col>
                  <a-col :span="3">
                    <a-popover title="微信扫一扫体验分享">
                      <template slot="content">
                        <qrcode-vue
                          :value="$getMobileLink(workInfo.id)"
                          :size="200"
                          level="H"
                        ></qrcode-vue>
                      </template>
                      <a-icon type="mobile" theme="twoTone" />
                    </a-popover>
                  </a-col>
                </a-row>
              </div>
            </a-col>
          </a-row>
          <a-divider />
          <div class="explain">
            <h3>作品说明：</h3>
            <span>{{
              workInfo.workDesc == null ? "暂无说明" : workInfo.workDesc
            }}</span>
          </div>
          <div class="explain">
            <h3>操作说明：</h3>
            <span>{{
              workInfo.playDesc == null ? "暂无说明" : workInfo.playDesc
            }}</span>
          </div>
        </div>
        <!-- 评论区 -->
        <div class="project-comment">
          <div class="publish" v-if="mineUserInfo">
            <a-row type="flex" justify="space-between">
              <a-col span="3" class="comment-user">
                <a-avatar icon="user" :src="mineUserInfo.avatarUrl ||'/img/avatar.png'" />
                <p>
                  {{ (mineUserInfo && mineUserInfo.realname) || "未登录" }}
                </p>
              </a-col>
              <a-col :span="16">
                <a-textarea
                  v-model="commentContent"
                  :rows="4"
                  placeholder="*说说这个作品怎么样吧"
                ></a-textarea>
              </a-col>
              <a-col :span="4">
                <div class="comment-btn">
                  <a-button
                    :disabled="mineUserInfo == null"
                    type="dashed"
                    @click="comment"
                    :loading="false"
                    >发表评论</a-button
                  >
                </div>
              </a-col>
            </a-row>
          </div>
          <a-divider />
          <a-list
            class="comment-list"
            item-layout="horizontal"
            :locale="{ emptyText: '暂无评论' }"
            :data-source="comments"
          >
            <a-list-item slot="renderItem" slot-scope="item">
              <a-comment :author="item.nickname">
                <a-avatar slot="avatar" icon="user" :src="item.avatar ||'/img/avatar.png'" />
                <template slot="actions">
                  <a-icon
                    type="like"
                    :theme="isStarComment ? 'filled' : 'outlined'"
                    @click="starComment(item)"
                  />
                  <span style="margin: '0 8px'; cursor: 'auto'">
                    &nbsp;{{ item.starNum }}
                  </span>
                  <a-icon
                    type="message"
                    theme="outlined"
                    @click="replyComment(item)"
                  />
                  <span key="comment-basic-reply-to" @click="replyComment(item)"
                    >&nbsp;回复({{ item.replyNum }})</span
                  >
                  <span style=""><a-icon type="alert" />举报</span>
                </template>
                <p slot="content">
                  {{ item.comment }}
                </p>
                <a-tooltip
                  slot="datetime"
                  :title="moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')"
                >
                  <span>{{ moment(item.createTime).fromNow() }}</span>
                </a-tooltip>
              </a-comment>
            </a-list-item>
            <div
              v-if="showLoadingMore"
              slot="loadMore"
              :style="{
                textAlign: 'center',
                marginTop: '12px',
                height: '32px',
                lineHeight: '32px',
              }"
            >
              <a-spin v-if="loadingMore" />
              <a-button v-else @click="moreComments"> 加载更多 </a-button>
            </div>
          </a-list>
        </div>
      </a-col>
      <a-col :span="8">
        <div class="author-panel">
          <a-skeleton
            active
            avatar
            :paragraph="{ rows: 6 }"
            :loading="authorInfo == null"
          >
            <a-card v-if="authorInfo != null">
              <div slot="title" class="author-detail">
                <a-row>
                  <a-col :span="6"
                    ><a-avatar
                      :size="50"
                      icon="user"
                      :src="authorInfo.avatar ||'/img/avatar.png'"
                    />
                  </a-col>
                  <a-col :span="18">
                    <h4 @click="$toUserDetail(authorInfo.id)">
                      {{ authorInfo.realname }}
                    </h4>
                    <a-tooltip :title="authorInfo.sign">
                      <p style="text-overflow: ellipsis; overflow: hidden">
                        {{
                          authorInfo.sign == null
                            ? "这个人还没有签名"
                            : authorInfo.sign
                        }}
                      </p>
                    </a-tooltip>
                  </a-col>
                </a-row>
              </div>
              <a slot="extra" href="#">
                <a-button @click="attentionUser(authorInfo.id)">{{
                  isAttention ? "已关注" : "+ 关注"
                }}</a-button>
              </a>
              <h3>TA的更多作品</h3>
              <a-list
                class="author-work-list"
                item-layout="horizontal"
                :data-source="authorWorks"
              >
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-row>
                    <a-col :span="12">
                      <a-tag class="work-type" color="blue">{{
                        item.codeType_dictText
                      }}</a-tag>
                      <img
                        @click="
                          $toProjectDetail(item.id);
                          getWorkInfo(item.id);
                        "
                        class="cover"
                        :src="item.codeType>4?'/img/code.png':item.workCover_url"
                      />
                    </a-col>
                    <a-col :span="12">
                      <p
                        style="color:black;"
                        @click="
                          $toProjectDetail(item.id);
                          getWorkInfo(item.id);
                        "
                      >
                        {{ item.workName }}
                      </p>
                      <p style="height: 44px;line-height:22px;-webkit-line-clamp: 2;text-overflow: ellipsis; overflow: hidden">
                        {{ item.workDesc || '暂无作品说明' }}
                      </p>
                      <div>
                        <a-icon type="eye" /> {{ item.viewNum }}
                        <a-divider type="vertical" />
                        <a-icon type="like" /> {{ item.starNum }}
                        <a-divider type="vertical" />
                        <a-icon type="heart" /> {{ item.collectNum }}
                      </div>
                    </a-col>
                  </a-row>
                </a-list-item>
              </a-list>
            </a-card>
          </a-skeleton>
        </div>
        <div>
          <!-- 推荐作品 -->
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import moment from "moment";
import Menu from "../../components/Menu";
import {
  userWorkList,
  workInfo,
  starWork,
  isStarWork,
  collectWork,
  isCollectWork,
  scoreWork,
  commentWork,
  workComments,
  starComment,
  getUserDetail,
  attentionUser,
  isAttentionUser,
} from "@/api/community";
export default {
  name: "ProjectDetail",
  components: {
    QrcodeVue,
    Menu,
  },
  data() {
    return {
      workId: "",
      workScore: 0,
      hoverWorkScore: 0,
      rateDesc: [
        "给作品评个分吧",
        "太糟糕了",
        "一般般",
        "还可以",
        "挺不错的",
        "简直神作",
      ],
      isCollect: 0,
      isStar: 0,
      workInfo: {},
      mineUserInfo: {},
      authorInfo: null,
      isAttention: false,
      comments: [],
      commentspage: 1,
      commentContent: "",
      replyCommentId: null,
      isStarComment: false,
      showLoadingMore: true,
      loadingMore: false,
      authorWorks: [],
    };
  },
  created() {
    this.mineUserInfo = this.$store.state.user.info;
    this.workId = this.$route.query.workId;
    this.getWorkInfo(this.workId);
  },
  mounted() {
    var that = this;
    //scratch全屏
    document.addEventListener("scratchFullScreen", function (e) {
      that.launchIntoFullscreen(document.getElementById("player"));
    });
    //scratch退出全屏
    document.addEventListener("scratchUnFullScreen", function (e) {
      that.exitFullscreen();
    });
    //scratch获取焦点
    document.addEventListener("scratchInit", function (e) {
      var p = document.getElementById("player");
      var s = p.contentDocument.getElementById("scratch");
      s.addEventListener("click", () => {
        p.focus();
      });
    });
  },
  methods: {
    moment,
    getUserInfo(userId) {
      getUserDetail(userId).then((res) => {
        if (res.success) {
          this.authorInfo = res.result.userInfo;
        }
      });
    },
    getWorkInfo(workId) {
      workInfo(workId).then((res) => {
        if (res.success) {
          this.workInfo = res.result;
          this.workScore =
            this.workInfo.average == null ? 0 : this.workInfo.average;
          this.workComments();
          if (this.mineUserInfo) {
            this.isCollectWork();
            this.isStarWork();
            this.isAttentionUser(this.workInfo.userId);
          }
          this.getUserInfo(this.workInfo.userId);
          this.getUserWorks(this.workInfo.userId);
        } else {
          this.$message.error("作品获取失败");
        }
      });
    },
    attentionUser(userId) {
      attentionUser(userId).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          if (res.message == "关注成功！") {
            this.isAttention = true;
          } else if (res.message == "取消成功！") {
            this.isAttention = false;
          }
        }
      });
    },
    isAttentionUser(userId) {
      isAttentionUser(userId).then((res) => {
        this.isAttention = res.success;
      });
    },
    getUserWorks(userId) {
      userWorkList(
        {userId, orderBy:"star_num", isAsc: true}).then((res) => {
        if (res.success) {
          this.authorWorks = res.result.records;
        }
      });
    },
    starWork() {
      starWork(this.workId).then((res) => {
        if (res.success) {
          if (res.message == "点赞成功") {
            this.workInfo.starNum += 1;
            this.isStar = 1;
          }
          this.$message.success(res.message);
        }
      });
    },
    isStarWork() {
      isStarWork(this.workId).then((res) => {
        this.isStar = res.success ? 1 : 0;
      });
    },
    collectWork() {
      collectWork(this.workId).then((res) => {
        if (res.success) {
          if (res.message == "收藏成功") {
            this.workInfo.collectNum += 1;
            this.isCollect = 1;
          } else {
            this.workInfo.collectNum -= 1;
            this.isCollect = 0;
          }
          this.$message.success(res.message);
        }
      });
    },
    isCollectWork() {
      isCollectWork(this.workId).then((res) => {
        this.isCollect = res.success ? 1 : 0;
        console.log(this.isCollect);
      });
    },
    scoreWork(v) {
      scoreWork(this.workId, this.workScore).then((res) => {
        if (res.success) {
          if (res.message == "评分成功") {
            this.workInfo.scoreNum += 1;
            this.workScore = this.workInfo.average;
          }
          this.$message.success(res.message);
        }
      });
    },
    onHoverWorkScore(v) {
      this.hoverWorkScore = v;
    },
    collectWork() {
      collectWork(this.workId).then((res) => {
        if (res.success) {
          if (res.message == "收藏成功") {
            this.isCollect = 1;
          } else {
            this.isCollect = 0;
          }
          this.$message.success(res.message);
        }
      });
    },
    workComments(page) {
      console.log(page);
      this.loadingMore = true;
      workComments(this.workId, page || 1).then((res) => {
        this.loadingMore = false;
        if (res.result.length == 0) {
          this.showLoadingMore = false;
        } else {
          this.commentspage = page || 1;
          this.comments = this.comments.concat(res.result);
        }
      });
    },
    moreComments() {
      this.workComments(this.commentspage + 1);
    },
    comment() {
      if (this.commentContent != "") {
        commentWork(this.workId, this.replyCommentId, this.commentContent).then(
          (res) => {
            if (res.success) {
              this.commentContent = "";
              this.replyCommentId = null;
              this.comments.unshift(res.result);
              this.$message.success(res.message);
            }
            // this.workComments();
          }
        );
      }
    },
    replyComment(item) {
      this.commentContent = "回复 " + item.createBy + ":";
      this.replyCommentId = item.id;
    },
    starComment(item) {
      starComment(item.id).then((res) => {
        this.$message.success(res.message);
        if (res.success) {
          this.isStarComment = true;
          if (res.message == "点赞成功") {
            item.starNum = item.starNum + 1;
          }
        }
      });
    },
    launchIntoFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    },

    exitFullscreen() {
      if (window.document.exitFullscreen) {
        window.document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        window.document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        window.document.webkitExitFullscreen();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.project-detail {
  margin: 50px 0;
  .scratch-player {
    iframe {
      width: 700px;
      height: 550px;
    }
  }
  .project-info {
    border: #e0e0e0 solid 1px;
    padding: 10px;
    .project-meta {
      text-align: left;
    }
    .project-op {
      color: #797979;
      .project-collect > div,
      .project-star > div {
        display: inline-block;
        line-height: 0;
        vertical-align: bottom;
      }
      .clap {
        margin-right: 8px;
      }
      .project-rate {
        // border: #c7c7c7 dotted 1px;
        // border-radius: 5px;
        padding: 2px 8px;
        line-height: 23px;
        .ant-rate-text{
          margin-top: 5px;
        }
      }
      .anticon {
        font-size: 45px;
      }
    }
    .explain {
      text-align: left;
      color: #6e6e6e;
      font-size: 16px;
      font-weight: 400;
      margin-bottom: 10px;
      line-height: 26px;
      h3 {
        display: inline;
      }
      span {
        color: #3c3b3b;
        display: inline;
      }
    }
  }
  .project-comment {
    border: #e0e0e0 solid 1px;
    padding: 10px;
    .publish {
      .comment-user {
        padding-top: 20px;
      }
      .comment-btn {
        padding-top: 10px;
        button {
          height: 80px;
        }
      }
    }
    .comment-list {
      color: #999;
      border: 1px solid #e9e9e9;
      border-top: none;
      padding: 0 20px;
      .item {
        padding: 20px;
        font-size: 13px;
        border-bottom: 1px solid #e9e9e9;
        .people {
          font-size: 30px;
        }
        .user {
          color: #666;
          font-size: 14px;
          margin-right: 5px;
        }
        .time {
          font-size: 12px;
        }
        span {
          margin-right: 30px;
        }
        p {
          margin: 10px 0;
        }
      }
      .more {
        font-size: 13px;
        text-align: center;
        padding-top: 40px;
        padding-bottom: 20px;
        > span {
          border: 1px solid #e9e9e9;
          line-height: 47px;
          width: 140px;
          height: 47px;
          display: inline-block;
          color: #999;
        }
      }
    }
  }
  .author-panel {
    .author-detail {
      text-align: left;
      p {
        color: gray;
      }
    }
    .author-work-list {
      .ant-list-item {
        display: block;
        text-align: left;

        .work-type {
          position: absolute;
          background: #e6f7ff80;
          border-color: #91d5ff85;
          top: 2px;
          left: 2px;
        }

        .cover {
          width: 150px;
          border: solid #dbdbdb 1px;
          border-radius: 2px;
        }
      }
    }
  }
}
</style>